<!-- medisync-hospital-frontend Application -->
<router-outlet></router-outlet>

<!-- Toast notifications -->
<app-toast></app-toast>
